class UserLocationMarkerCtrl {

    constructor($scope, storeServ, mapHelperServ) {
        this.$scope = $scope;
        this.storeServ = storeServ;
        this.mapHelperServ = mapHelperServ;

        this.ngOnInit();
    }

    /**
     *  Init.
     */

    ngOnInit() {
        this.searchedPlaceCoordinates = this.storeServ.getState().searchedPlaceCoordinates;

        this.createUserLocationMarker();
        
        this.setUserLocationMarkerOnMap();
        
        this.addUserLocationMarkerClickListener();
        
        this.$scope.$on('$destroy', this.ngOnDestroy.bind(this));
    }

    createUserLocationMarker() {
        this.userLocationMarker = this.mapHelperServ._createMarker(
            this.searchedPlaceCoordinates.location,
            this.markerOptions.icon.user,
            this.markerOptions.zIndex.user
        );
    }

    setUserLocationMarkerOnMap() {
        this.userLocationMarker.setMap(this.map);
    }

    addUserLocationMarkerClickListener() {
        this.userLocationMarkerClickListener = this.userLocationMarker.addListener('click', this.onUserLocationMarkerClick.bind(this));
    }

    onUserLocationMarkerClick() {
        this.storeServ.dispatch({
            type: 'TOGGLE_INFO_WINDOW',
            props: null
        });

        this.storeServ.dispatch({
            type: 'TOGGLE_INFO_WINDOW',
            props: {
                template: 'userLocationMarker',
                markerProperties: {
                    lat: this.userLocationMarker.getPosition().lat(),
                    lng: this.userLocationMarker.getPosition().lng(),
                    pixelOffset: -53
                }
            }
        });
    }

    ngOnDestroy() {
        this.userLocationMarkerClickListener.remove();
        
        this.userLocationMarker.setMap(null);

        this.storeServ.getState().toggleInfoWindow && this.storeServ.dispatch({
            type: 'TOGGLE_INFO_WINDOW',
            props: null
        });
    }
}

UserLocationMarkerCtrl.$inject = ['$scope', 'storeServ', 'mapHelperServ'];

var userLocationMarkerDirective = function() {
    return {
        restrict: 'E',
        scope: {},
        controllerAs: 'vm',
        controller: UserLocationMarkerCtrl,
        bindToController: {
            map: '=',
            markerOptions: '='
        }
    };
};

export default userLocationMarkerDirective;